import {
    BookIcon,
    CalendarIcon,
    CalculatorIcon,
    ChartBarIcon,
    FileTextIcon,
    GaugeIcon,
    LayersIcon,
    LineChartIcon,
    PercentIcon,
    WalletIcon,
} from "lucide-react";
import { NavSection } from "@/lib/shadcn/components/sidebar/nav-platform";

export const userSidebarItems: NavSection[] = [
    {
        title: "Platform",
        items: [
            {
                title: "Reports",
                url: "/reports/",
                icon: FileTextIcon,
            },
            {
                title: "Reservations",
                url: "/reservations/",
                icon: BookIcon,
            },
            {
                title: "Calendar",
                url: "/calendar/",
                icon: CalendarIcon,
            },
            {
                title: "Expenses",
                url: "/expenses/",
                icon: WalletIcon,
            },
            {
                title: "Trends",
                url: "/trends/",
                icon: LineChartIcon,
            },
            {
                title: "Trend Graphs",
                url: "/graphs/apartments",
                icon: ChartBarIcon,
            },
            {
                title: "Aggregate Expenses",
                url: "/aggregate-expenses/",
                icon: CalculatorIcon,
            },
            {
                title: "Booking Pace",
                url: "/owner-booking-pace/",
                icon: GaugeIcon,
            },
            {
                title: "Occupancy Explorer",
                url: "/owner-occupancies/",
                icon: PercentIcon,
            },
            {
                title: "BLT Breakdown",
                url: "/owner-blt/",
                icon: LayersIcon,
            },
        ],
    },
];
